import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lui-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  @Input() alt: string = 'Lockton';
}
